import axios from 'axios'

// You can use your own logic to set your local or production domain
const managerDomain = process.env.VUE_APP_MANAGER_API_URL
// The base URL is empty this time due we are using the jsonplaceholder API
const baseURL = `${managerDomain}/api`

const headers = {
  'Content-Type': 'application/json',
  'X-Requested-With': 'XMLHttpRequest',
  'Access-Control-Allow-Origin': '*',
  'Access-Control-Expose-Headers': '*',
}

const $axios = axios.create({
  baseURL: baseURL,
  headers: headers,
  withCredentials: true,
  responseType: 'json',
})

$axios.interceptors.request.use(request => {
  return request
})

$axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    if (error.response.status === 401) {
      window.location.href = `${managerDomain}/login`
    } else {
      return Promise.reject(error)
    }
  },
)

export default {
  /**
   * 3之助共通メインメニューリストを取得する
   * @returns {Array} メインメニューリスト
   */
  async getMainMenu() {
    return await $axios
      .get(`/forexternal/main_menu`)
      .then(response => {
        return response.data.menuItems
      })
      .catch(e => {
        console.log(e)
        return []
      })
  },
}
